<template>
  <div class="fullContainer">
    <ul class="reserveMeni01 d-flex">
      <li :class="head_link_class('drive')">
        <router-link to="/reservation/drive" class="reserveMeni01__link" >
          <span class="reserveMeni01__iconWrapper reserveMeni01__iconWrapper--run">
            <img class="reserveMeni01__icon" src="@/assets/img/main/reserve_menu01_img_01.png" alt=""/>
            <img class="reserveMeni01__icon" src="@/assets/img/main/reserve_menu01_img_01_on.png" alt=""/>
          </span>
          <span class="reserveMeni01__text">{{word_chg('走行')}}</span>
        </router-link>
      </li>
      <li :class="head_link_class('lodge')">
        <router-link to="/reservation/lodging" class="reserveMeni01__link" >
          <span class="reserveMeni01__iconWrapper reserveMeni01__iconWrapper--stay">
            <img class="reserveMeni01__icon" src="@/assets/img/main/reserve_menu01_img_02.png" alt=""/>
            <img class="reserveMeni01__icon" src="@/assets/img/main/reserve_menu01_img_02_on.png" alt=""/>
          </span>
          <span class="reserveMeni01__text">{{word_chg('宿泊')}}</span>
        </router-link>
      </li>
      <li :class="head_link_class('facility')">
        <router-link to="/reservation/facility" class="reserveMeni01__link" >
          <span class="reserveMeni01__iconWrapper reserveMeni01__iconWrapper--facility">
            <img class="reserveMeni01__icon" src="@/assets/img/main/reserve_menu01_img_03.png" alt=""/>
            <img class="reserveMeni01__icon" src="@/assets/img/main/reserve_menu01_img_03_on.png" alt=""/>
          </span>
          <span class="reserveMeni01__text">{{word_chg('施設')}}</span>
        </router-link>
      </li>
    </ul>
    <!-- {{ reserve_type }} -->
    <ul :class="tab_list_class">
      <li :class="tab_link_class('reserve')">
        <router-link :to="'/reservation/' + linkTo" class="reserveMeni01__link" >
          <span class="reserveMeni02__text">{{word_chg('予約する')}}</span>
        </router-link>
      </li>
      <li :class="tab_link_class('check')">
        <router-link :to="'/reserved/' + linkTo" class="reserveMeni01__link">
          <span class="reserveMeni02__text">{{word_chg('予約確認')}}</span>
        </router-link>
      </li>
      <li :class="tab_link_class('history')">
        <router-link :to="'/history/' + linkTo" class="reserveMeni01__link" >
          <span class="reserveMeni02__text">{{historyLabel}}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'BsReserveHeaderView',
    data: function () {
        return {
            // 'tab_active': 'drive',//or th ead
        }
    },
    props: {
      reserve_type: {
        type: String,
        default: 'drive'
      },
      reserve_target: {
        type: String,
        default: 'reserve'
      },
    },
    components: {
        // BsPageTitle,
    },
    methods: {
    },
    computed: {
      historyLabel: function(){
        if(this.reserve_type == 'drive'){
          return this.word_chg('走行履歴')
        }
        else if(this.reserve_type == 'lodge'){
          return this.word_chg('宿泊履歴')
        }
        else if(this.reserve_type == 'facility'){
          return this.word_chg('利用履歴')
        }
        else{
          return this.word_chg('利用履歴')
        }

      },
      linkTo: function () {
        let path = '';
        if(this.reserve_type == 'drive'){
          path += 'drive';
        }
        else if(this.reserve_type == 'lodge'){
          path += 'lodging';
        }
        else if(this.reserve_type == 'facility'){
          path += 'facility';
        }
        return path;
      },
      head_link_class: function(){
        const now_type = this.reserve_type;
        return function(type){
          let classParam = 'reserveMeni01__li ';
          if(now_type == type){
            classParam += 'reserveMeni01__li--active';
          }
          return classParam;
        }
      },
      tab_list_class: function(){
        let classParam = 'reserveMeni02 d-flex reserveMeni02--';
        if(this.reserve_type == 'drive'){
          classParam += 'run';
        }
        else if(this.reserve_type == 'lodge'){
          classParam += 'stay';
        }
        else if(this.reserve_type == 'facility'){
          classParam += 'facility';
        }
        return classParam;
      },
      tab_link_class: function(){
        const now_target = this.reserve_target;
        return function(target){
          let classParam = 'reserveMeni02__li ';
          if(now_target == target){
            classParam += 'reserveMeni02__li--active';
          }
          return classParam;
        }
      }
    },
  }
</script>
